import React from 'react';
import { JsonLd } from "react-schemaorg";
export default function QAPageSchema(item) {
    return (React.createElement(JsonLd, { item: {
            '@context': "https://schema.org",
            '@type': "QAPage",
            mainEntity: {
                '@type': "Question",
                name: item.question ? item.question : "",
                acceptedAnswer: {
                    '@type': "Answer",
                    text: item.answer ? item.answer : "",
                },
                answerCount: 1
            }
        } }));
}
